"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ApptList_1 = __importDefault(require("../ApptTime/ApptList"));
const constants_1 = require("../../lib/constants");
const RescheduleReason_1 = __importDefault(require("../RescheduleReason/RescheduleReason"));
const SelectAction_1 = __importDefault(require("../SelectAction/SelectAction"));
const ErrorPage_1 = __importDefault(require("../../../components/ErrorPage/ErrorPage"));
const messages_1 = __importDefault(require("../../lib/messages"));
const Confirmation_1 = __importDefault(require("../Confirmation/Confirmation"));
const styles_1 = require("../../../components/LayoutFactory/styles");
const SwitchByState = ({ service, matches, context, headerHeight, bodyIsAnimating = false }) => {
    if (matches(constants_1.states.manageAppointment)) {
        return (react_1.default.createElement(SelectAction_1.default, { service: service }));
    }
    if (matches(constants_1.states.reschedule)) {
        return (react_1.default.createElement(ApptList_1.default, { service: context.apptTimeMachine, headerHeight: headerHeight }));
    }
    if (matches(constants_1.states.rescheduleReason)) {
        return (react_1.default.createElement(RescheduleReason_1.default, { service: context.reasonMachine }));
    }
    if (matches(constants_1.states.modificationWindowExpired)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.modificationWindowExpired });
    }
    if (matches(constants_1.states.alreadyCanceled)) {
        return (react_1.default.createElement(styles_1.StyledContainer, null,
            react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.previouslyCanceledPageHeading })));
    }
    if (matches(constants_1.states.alreadyRescheduled)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.appointmentAlreadyRescheduled });
    }
    if (matches(constants_1.states.disabled)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.rescheduleDisabled });
    }
    if (matches(constants_1.states.appointmentMissed)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.appointmentMissed });
    }
    if (matches(constants_1.states.appointmentRescheduled)) {
        return (react_1.default.createElement(Confirmation_1.default, { service: service, bodyIsAnimating: bodyIsAnimating }));
    }
    return null;
};
exports.default = SwitchByState;
//# sourceMappingURL=SwitchByState.js.map